import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import appointmentsRoutes from './appointments/appointments.routes';
import pipelineRoutes from './pipeline/pipeline.routes';
import retentionRoutes from './retention/retention.routes';
import professionalsRoutes from './professionals/professionals.routes';
import establishmentsRoutes from './establishments/establishments.routes';
import commercialOffersRoutes from './commercialOffers/commercialOffers.routes';
import resultGalleryRoutes from './resultGallery/resultGallery.routes';
import attendanceDirectivesRoutes from './attendanceDirectives/attendanceDirectives.routes';
import organizationsRoutes from './organizations/organizations.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...appointmentsRoutes.routes,
        ...pipelineRoutes.routes,
        ...retentionRoutes.routes,
        ...professionalsRoutes.routes,
        ...establishmentsRoutes.routes,
        ...commercialOffersRoutes.routes,
        ...resultGalleryRoutes.routes,
        ...attendanceDirectivesRoutes.routes,
        ...organizationsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
